<template>
  <span class="form-group__message">
    {{ message }}
  </span>
</template>

<script>
export default {
  name: 'ValidationMessage',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
};
</script>
